<script>
import { mapState } from 'vuex';

import Icon from '~/components/icon.vue';

export default {
  components: {
    Icon
  },

  data() {
    return {
      scope: {
        scope: 'pay.js.marketing.merchant_contact'
      }
    };
  },

  computed: {
    ...mapState({
      contact: 'merchantContactInfo',
    }),

    contactCopyright() {
      return `© ${this.contact.year} ${this.contact.company}`;
    },

    contactAddress() {
      return `${this.contact.address} - ${this.contact.zipcode} - ${this.contact.city}`;
    },

    contactLine() {
      return `${this.contactCopyright} - ${this.contactAddress}`;
    }
  }
};
</script>

<template>
  <div class="c-merchant-contact-footer p-3">
    <span class="c-merchant-contact-footer__item">
      {{ contactLine }}
    </span>

    <span
      v-if="contact.phone"
      class="c-merchant-contact-footer__item"
    >
      <icon
        class="c-merchant-contact-footer__icon"
        name="phone"
        size="small"
      />
      {{ contact.phone }}
    </span>

    <span
      v-if="contact.email"
      class="c-merchant-contact-footer__item"
    >
      <icon
        class="c-merchant-contact-footer__icon"
        name="mail"
        size="small"
      />
      {{ contact.email }}
    </span>

    <span class="ms-5" />

    <span
      v-if="contact.vat"
      class="c-merchant-contact-footer__item"
    >
      {{ t('vat', scope) }}: {{ contact.vat }}
    </span>

    <span class="c-merchant-contact-footer__item">
      {{ t('chamber_of_commerce', scope) }}: {{ contact.chamberOfCommerce }}
    </span>
  </div>
</template>

